import { api } from './api';

export interface MasqueradeUser {
  id: number;
  name: string;
  email: string;
  role: string;
  status: string;
  firms?: Array<{
    id: number;
    name: string;
    type: string;
  }>;
}

export interface MasqueradeStatus {
  is_masquerading: boolean;
  can_masquerade?: boolean;
  original_user?: {
    id: number;
    name: string;
    email: string;
  };
  masquerade_started_at?: string;
  duration?: string;
}

export interface MasqueradeResponse {
  success: boolean;
  message?: string;
  data?: {
    user: any;
    token?: string;
    original_user?: {
      id: number;
      name: string;
      email: string;
    };
    is_masquerading: boolean;
    masquerade_started_at?: string;
    masquerade_duration?: string;
  };
}

export interface UsersListResponse {
  success: boolean;
  data: {
    data: MasqueradeUser[];
    current_page: number;
    last_page: number;
    per_page: number;
    total: number;
  };
}

export const masqueradeService = {
  /**
   * Get list of users that can be masqueraded
   */
  async getUsersList(params: {
    search?: string;
    role?: string;
    firm_id?: number;
    page?: number;
  } = {}): Promise<UsersListResponse> {
    const response = await api.get('/masquerade/users', { params });
    return response.data;
  },

  /**
   * Get current masquerade status
   */
  async getStatus(): Promise<{ success: boolean; data: MasqueradeStatus }> {
    const response = await api.get('/masquerade/status');
    return response.data;
  },

  /**
   * Start masquerading as a user
   */
  async startMasquerade(userId: number): Promise<MasqueradeResponse> {
    const response = await api.post(`/masquerade/start/${userId}`);
    return response.data;
  },

  /**
   * Stop masquerading and return to original user
   */
  async stopMasquerade(): Promise<MasqueradeResponse> {
    const response = await api.post('/masquerade/stop');
    return response.data;
  }
};





